import React, { useMemo } from "react";
import { Field } from "react-final-form";

import TextInput from "../../inputs/TextInput";
import RffInputWrapper from "../shared/RffInputWrapper";

import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";

const RffNumberField = ({
  name,
  label,
  required,
  placeholder = "Enter number",
  suppressGrid,
  disabled,
  onBlur,
  size,
  sx,
  min,
  max,
  helperText,
}) => {
  // Build a single validate fn that covers required, min and max
  const validate = useMemo(() => {
    return (value) => {
      if (required && (value === undefined || value === null || value === "")) {
        return VALIDATOR_REQUIRE(value);
      }
      if (min !== undefined && value < min) {
        return `${label} must be at least ${min}`;
      }
      if (max !== undefined && value > max) {
        return `${label} must be at most ${max}`;
      }
      return undefined;
    };
  }, [required, min, max, label]);

  const formatNumber = (value) => {
    if (value === undefined || value === null || value === "") return "";
    return new Intl.NumberFormat().format(value);
  };

  const parseNumber = (value) => {
    if (value === undefined || value === null || value === "") return undefined;
    return Number(value.replace(/,/g, ""));
  };

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      helperText={helperText}
    >
      <Field
        name={name}
        parse={parseNumber}
        format={formatNumber}
        validate={validate}
        render={({ input, meta }) => (
          <TextInput
            {...input}
            onBlur={onBlur}
            placeholder={placeholder}
            disabled={disabled}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            sx={sx}
            type="tel" // Better for iOS numeric keyboards
            inputMode="numeric" // Numeric keyboard on all platforms
            pattern="[0-9]*"
            inputProps={{ min, max }} // Native min/max attributes
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffNumberField;
